import { staticIdDecorator } from './user.action.interceptor';
import { CONTEXT_SOURCE, SYNC_CONTEXT_SOURCE, USER_TYPE } from './const';
import Emitter from 'tiny-emitter';
import * as EventType from '../eventBusType';
@staticIdDecorator(SYNC_CONTEXT_SOURCE)
class SyncContext extends Emitter {
  constructor (userType) {
    super();
    this.userType = userType;
    this.source = CONTEXT_SOURCE.LOCAL;
    this.timer = null;
  }
  /**
   * 设置当前执行源
   * @param {*} source 
   * @returns 
   */
  setContextSource (source) {
    this.source = source;
    if (this.userType === USER_TYPE.SALES && this.source === CONTEXT_SOURCE.REMOTE) {
      this.emit(EventType.REALTIME_SYNC_LOCKED, source);
      this.resetSourceTimer();
    }
  }
  resetSourceTimer () {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.timer = setTimeout(() => {
      // 独占1000ms后释放
      this.source = CONTEXT_SOURCE.LOCAL;
      this.timer = null;
      this.emit(EventType.REALTIME_SYNC_UNLOCKED, this.source);
    }, 1000);
  }
  getContextSource () {
    return this.source;
  }
}
export { SyncContext }; 